import React, { useState } from "react";

import { Redirect } from "react-router-dom";

import ApplicationSubmitted from "@/components/ApplicationSubmitted";
import { AFFILIATE } from "@/core/constants";
import { CMP_SHOP_URL, ERROR_404_URL } from "@/core/urls";
import useCmpRelatedUrl from "@/hooks/organisations/useCmpRelatedUrl";
import useDocTitle from "@/hooks/use-doc-title";
import PractitionerApplication from "@/tpo/partnerDashboard/practitioner/Application";

import { useAuthContext } from "./AuthProvider";

function PartnersPage() {
  useDocTitle("Partners");

  const { user } = useAuthContext();
  const [formSubmitted, setFormSubmitted] = useState(false);

  const { resolvedUrls } = useCmpRelatedUrl();

  if (formSubmitted) {
    return <ApplicationSubmitted />;
  }
  if (user) {
    if (!user.practitionerProfile) {
      return <PractitionerApplication setFormSubmitted={setFormSubmitted} />;
    }

    if (user.practitionerProfile.tier === AFFILIATE) {
      return <Redirect to={ERROR_404_URL} />;
    }

    if (!user.practitionerProfile.approved) {
      return <ApplicationSubmitted />;
    }

    return <Redirect to={resolvedUrls[CMP_SHOP_URL]} />;
  }

  return <PractitionerApplication setFormSubmitted={setFormSubmitted} />;
}

export default PartnersPage;
